export default {
  name: 'emoji',
  props: {
    all: Boolean,
    trueRow: Boolean,

  },
  setup() {
    return {
    }
  },
}
